<template>
  <div class="card card-fluid mb-0" v-if="protocol">
    <div class="card-body">
      <div class="todo-list">
        <div class="todo-header text-truncate">
          <b>Proceso de registro:</b>
        </div>
        <div class="todo py-2 pl-2"
             :class="{ 'badge-subtle badge-success': protocol }">
          <div class="custom-control custom-checkbox">
            <input type="checkbox"
                   class="custom-control-input"
                   disabled
                   :checked="protocol">
            <label
              class="custom-control-label"
              style="text-decoration: none;"
              for="general_data">
                Datos generales del protocolo.
              <span class="badge badge-subtle badge-success"
                    v-if="protocol">Completado</span>
            </label>
          </div>
        </div>
        <div class="todo py-2 pl-2"
             :class="{ 'badge-subtle badge-success': checkResearchersInvitations() }">
            <div class="custom-control custom-checkbox">
              <input type="checkbox"
                      class="custom-control-input"
                      disabled
                      :checked="checkResearchersInvitations()">
              <label
                class="custom-control-label"
                style="text-decoration: none;"
                for="total_pending_coresearchers">
                Vincular coinvestigadores al protocolo.
                <span class="badge badge-subtle badge-success"
                      v-if="checkResearchersInvitations()">Completado</span>
                <span class="badge badge-subtle badge-danger"
                      v-else>Obligatorio</span>
              </label>
            </div>
        </div>
        <div class="todo py-2 pl-2"
             :class="{ 'badge-subtle badge-success': protocol.primary_line }">
            <div class="custom-control custom-checkbox">
              <input type="checkbox"
                      class="custom-control-input"
                      disabled
                      :checked="protocol.primary_line">
              <label
                class="custom-control-label"
                style="text-decoration: none;"
                for="total_linked_research_lines">
                Registrar líneas de investigación.
                <span class="badge badge-subtle badge-success"
                      v-if="protocol.primary_line">Completado</span>
                <span class="badge badge-subtle badge-danger"
                      v-else>Obligatorio</span>
              </label>
            </div>
        </div>
        <div class="todo py-2 pl-2"
             :class="{ 'badge-subtle badge-success': checkFinancingInformation() }">
            <div class="custom-control custom-checkbox">
              <input type="checkbox"
                      class="custom-control-input"
                      disabled
                      :checked="checkFinancingInformation()">
              <label
                class="custom-control-label"
                style="text-decoration: none;"
                for="financing_information">
                Detalles de financiamiento.
                <span class="badge badge-subtle badge-success"
                      v-if="checkFinancingInformation()">Completado</span>
                <span class="badge badge-subtle badge-danger"
                      v-else>Obligatorio</span>
              </label>
            </div>
        </div>
        <div class="todo py-2 pl-2"
             :class="{ 'badge-subtle badge-success': checkEthicsQuestionnaire() }">
            <div class="custom-control custom-checkbox">
              <input type="checkbox"
                     class="custom-control-input"
                     disabled
                     :checked="checkEthicsQuestionnaire()">
              <label
                class="custom-control-label"
                style="text-decoration: none;"
                for="ethics_questionnaire">
                Responder cuestionario de comité de ética.
                <span class="badge badge-subtle badge-success"
                      v-if="checkEthicsQuestionnaire()">Completado</span>
                <span class="badge badge-subtle badge-danger"
                      v-else>Obligatorio</span>
              </label>
            </div>
        </div>
        <div class="todo py-2 pl-2"
             :class="{ 'badge-subtle badge-success': checkBiosecurityQuestionnaire() }">
            <div class="custom-control custom-checkbox">
                <input type="checkbox"
                       class="custom-control-input"
                       disabled
                       :checked="checkBiosecurityQuestionnaire()">
                <label
                  class="custom-control-label"
                  style="text-decoration: none;"
                  for="biosecurity_questionnaire">
                  Responder cuestionario del comité de bioseguridad.
                  <span class="badge badge-subtle badge-success"
                      v-if="checkBiosecurityQuestionnaire()">Completado</span>
                  <span class="badge badge-subtle badge-danger"
                        v-else>Obligatorio</span>
                </label>
            </div>
        </div>
        <div class="todo py-2 pl-2"
             :class="{ 'badge-subtle badge-success': protocol.file }">
            <div class="custom-control custom-checkbox">
              <input type="checkbox"
                     class="custom-control-input"
                     disabled
                     :checked="protocol.file">
              <label
                class="custom-control-label"
                style="text-decoration: none;"
                for="protocol_file">
                Adjuntar protocolo en texto completo (PDF).
                <span class="badge badge-subtle badge-success"
                      v-if="protocol.file">Completado</span>
                <span class="badge badge-subtle badge-danger"
                      v-else>Obligatorio</span>
              </label>
            </div>
        </div>
        <div class="todo py-2 pl-2"
             :class="{ 'badge-subtle badge-success': protocol.attachments.length > 0 }">
            <div class="custom-control custom-checkbox">
              <input type="checkbox"
                     class="custom-control-input"
                     disabled
                     :checked="protocol.attachments.length > 0">
              <label
                class="custom-control-label"
                style="text-decoration: none;"
                for="protocol_attachments">
                Anexos del protocolo.
                <span class="badge badge-subtle badge-success"
                      v-if="protocol.attachments.length > 0">Completado</span>
              </label>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  
  export default {
    name: 'ProtocolProcesses',
    data () {
      return {}
    },
    computed: {
      ...mapGetters({
        protocol: 'protocols/selectedProtocol',
      }),
    },
    methods: {
      checkResearchersInvitations () {
        let researchersAccepted = true
        let externalResearchersAccepted = true
        
        if (this.protocol.researchers.length === 0 && this.protocol.externalResearchers.length === 0) {
          return true
        }
        
        this.protocol.researchers.forEach(researcher => {
          if (researcher.status.key === 'enviado') {
            researchersAccepted = false
          }
        })

        this.protocol.externalResearchers.forEach(researcher => {
          if (!researcher.invited_by_email && researcher.status.key === 'enviado') {
            externalResearchersAccepted = false
          }

          if (researcher.invited_by_email && researcher.is_accepted === null) {
            externalResearchersAccepted = false
          }
        })
        
        return researchersAccepted && externalResearchersAccepted
      },
      checkFinancingInformation () {
        if (this.protocol.financing_information && !Object.keys(this.protocol.financing_information).includes('id')) {
          return false
        }

        if (!this.protocol.has_financing_information) {
          return true
        }
        
        if (this.protocol.has_financing_information &&
          this.protocol.funders.length) {
          // Check if all funders have their file.
          let haveFiles = true
          
          this.protocol.funders.forEach(funder => {
            if (funder.pivot.agreement_path === null) {
              haveFiles = false
            }
          })
          
          return haveFiles
        }
        
        return false
      },
      checkEthicsQuestionnaire () {
        return this.protocol.ethics_questionnaire !== null
      },
      checkBiosecurityQuestionnaire () {
        return (this.protocol.biosecurity_questionnaire !== null && 
               this.protocol.biosecurity_questionnaire.id) ||
               (this.protocol.biosecurity_questionnaire_legacy &&
               this.protocol.biosecurity_questionnaire_legacy !== null && 
               this.protocol.biosecurity_questionnaire_legacy.id) 
      },
    },
  }
</script>
